var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 28,
    rx: 27.7948,
    ry: 28,
    fill: "#42BE40",
    fillOpacity: 0.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 45.9487C37.8398 45.9487 45.8168 37.9128 45.8168 28C45.8168 18.0872 37.8398 10.0513 27.9997 10.0513C18.1595 10.0513 10.1825 18.0872 10.1825 28C10.1825 37.9128 18.1595 45.9487 27.9997 45.9487Z",
    fill: "#42BE40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3181 35.4964L17.8448 29.6858C17.0954 28.8903 17.1384 27.6317 17.9404 26.8885C18.7425 26.1452 20.0113 26.188 20.7607 26.9834L24.9825 31.4654L31.6652 25.2721C31.7253 25.2163 31.7882 25.1653 31.8531 25.1183L34.9957 22.2059C35.7977 21.4627 37.0667 21.5054 37.8159 22.3009C38.5652 23.0963 38.5221 24.355 37.7202 25.0983L28.1219 33.9937L28.1116 33.9828L24.7914 37.0599L23.3181 35.4964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.ad31941491ecbccf07eb0690f185d40d.svg";
export { ForwardRef as ReactComponent };